"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

interface ModeToggleProps {
  "data-cy"?: string;
  className?: string;
}

export function ModeToggle({ "data-cy": dataCy, className }: ModeToggleProps) {
  const { resolvedTheme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(resolvedTheme === "dark" ? "light" : "dark");
  };

  return (
    <div className={` `}>
      <button
        onClick={toggleTheme}
        data-cy={dataCy}
        className={`flex h-10 w-10 items-center justify-center rounded-full hover:bg-black/5 dark:hover:bg-white/10 transition ${className ?? ""}`}
        aria-label="Toggle Theme"
      >
        {resolvedTheme === "dark" ? <Sun size={20} /> : <Moon size={20} />}
      </button>
    </div>
  );
}
